// extracted by mini-css-extract-plugin
export default {"price":"K7-z","onSale":"L7-z","msrpLabelPrice":"M7-z","msrpLabel":"N7-z","originalPrice":"O7-z","percentOff":"P7-z"};